import * as React from "react";
//#region components
import LoginLayout from "./loginLayout";
import ResetPassword from "./resetPassword";
//#endregion

const ResetPasswordContainer: React.FC = () => {
  return <LoginLayout render={(displayType) => <ResetPassword displayType={displayType} />} />;
};

export default ResetPasswordContainer;
